import {
    AfterViewInit, Component, Input, OnInit,
    ViewEncapsulation
} from '@angular/core';
import { DistanceToDeadlineService } from '../../../../payment/services/distance-to-deadline.service';
import { OrderDetails } from '../../../models/orders/details';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'account-orders-details-basic-data',
    templateUrl: './account.orders.details.basic-data.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsBasicDataComponent implements OnInit {
    @Input('order') order: OrderDetails;
    @Input('deliverable') deliverable: boolean;

    public daysToDeadline;
    public daysToDeadlineLimit;

    constructor(
        protected distanceToDeadlineService: DistanceToDeadlineService,
        protected toastr: ToastrService,
        protected translate: TranslateService
    ) {}

    ngOnInit() {
        if (this.deliverable && this.hasZipCodeRange()) {
            this.daysToDeadline = this.distanceToDeadlineService
                .calculate(this.order.deliveries.zip_code_range.time_cost);
            if (null !== this.order.deliveries.zip_code_range.time_cost_limit) {
                this.daysToDeadlineLimit = this.distanceToDeadlineService
                    .calculate(this.order.deliveries.zip_code_range.time_cost_limit);
            }
        }
    }

    /**
     * Change qrcode tag source to fallback api.
     **/
    public changeQrCodeSource(tag) {
        tag.setAttribute(
            'src',
            `https://api.qrserver.com/v1/create-qr-code/?data=${this.order.payment_code}&size=250x250`
        );
    }
    /**
     * Display copied message.
     **/
    public copied() {
        this.translate
            .get('ACCOUNT.ORDERS.DETAILS.BASIC_DATA.PAYMENT_CODE_COPIED')
            .subscribe(message => {
                this.toastr.info(message);
            });
    }
    /**
     * Check if days to deadline is a defined number
     **/
    public hasDefinedDeadline() {
        return false === isNaN(this.daysToDeadline);
    }
    /**
     * Check if zip code range is defined into deliveries object.
     **/
    public hasZipCodeRange() {
        return typeof this.order.deliveries.zip_code_range === 'object'
            && this.order.deliveries.zip_code_range.time_cost !== undefined
            && this.order.deliveries.zip_code_range.time_cost_limit !== undefined
    }
    /**
     * Check if order zip code range has time cost limit.
     **/
    public hasDefinedLimit() {
        return this.deliverable
            && this.order.deliveries !== undefined
            && this.order.deliveries.zip_code_range !== undefined
            && null !== this.order.deliveries.zip_code_range.time_cost_limit;
    }
    /**
     * Check if order has schedule data.
     **/
    public hasSchedule() {
        return this.deliverable
            && this.order.schedule !== undefined
            && null !== this.order.schedule;
    }
    /**
     * Item extra fields length is greater than zero.
     **/
    public hasExtraFields(order): boolean {
        return Object.keys(order.extra_fields).length > 0;
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFields(order) {
        return Object
        .keys(order.extra_fields)
        .map(slug => order.extra_fields[slug]);
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFieldValues(extraField) {
        const values = extraField.values || {};
        return Object.keys(values).map(key => values[key]);
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getEntityReferenceKeys(entityReference) {
        return Object.keys(entityReference);
    }
    /**
     * Return if field is not identification field (id or real_id).
     **/
    public isNotId(slug: string) {
        return slug !== 'id'
            && slug !== 'real_id';
    }
    public isString(value) {
        return typeof value === 'string';
    }
    public isSingleOption(value) {
        return null !== value
            && typeof value === 'object'
            && false === Array.isArray(value)
            && typeof value['key'] === 'string'
            && typeof value['label'] === 'string';
    }
    public isMultipleOptions(value) {
        return null !== value
            && typeof value === 'object'
            && true === Array.isArray(value)
            && true === this.isSingleOption(value[0] || {});
    }
    public isEntityReference(extraFieldValue: any) {
        return typeof extraFieldValue === 'object';
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/account/orders/details/basic-data/account.orders.details.basic-data.component.ts